import VueRouter from 'vue-router'
const Home = ()=> import('@/pages/Home')
const About = ()=> import('@/pages/About')
const News = ()=> import('@/pages/News')
const NewsDet = ()=> import('@/pages/News/detail.vue')
const Download = ()=>  import('@/pages/Download')
const Innovation = ()=> import('@/pages/Innovation')
const Product = () => import('@/pages/Product')
const Module = () => import('@/pages/Product/module.vue')
const Dealer = () => import('@/pages/Product/dealer.vue')
const Solution = () => import('@/pages/Solution')
const Case = () => import('@/pages/Case')

export default new VueRouter({
    mode:'history',
    strict: false,
    routes:[
        {
            path: '/cn',
            component: Home
        },
        {
            path: '/cn/about',
            component: About
        },
        {   
            name:'news',
            path: '/cn/news/:p?',
            component: News,
            props({query}){
                return { p:query.p }
            }
        },
        {
            path: '/cn/newsdet',
            component: NewsDet,
            props({query}){
                return { id:query.id }
            }
        },
        {
            name:'load',
            path: '/cn/download',
            component: Download,
            props({query}){
                return { pid:query.pid, cid:query.cid, p:query.p }
            }
        },
        {
            path: '/cn/innovation',
            component: Innovation
        },
        {
            path: '/cn/product',
            component: Product,
            props({query}){
                return { id:query.id }
            }
        },
        {
            path:'/cn/module',
            component: Module,
        },
        {
            path:'/cn/dealer',
            component: Dealer,
        },
        {
            path: '/cn/solution',
            component: Solution,
            props({query}){
                return{ id:query.id }
            }
        },{
            name:'case',
            path:'/cn/case',
            component:Case,
            props({query}){
                return { p:query.p }
            }
        }
    ]
})